/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S4_HeadingInputs */

const tr_onbilgi_s4_heading = /** @type {(inputs: Onbilgi_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Ödeme Yöntemi`)
};

const en_onbilgi_s4_heading = /** @type {(inputs: Onbilgi_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Payment Method`)
};

const de_onbilgi_s4_heading = /** @type {(inputs: Onbilgi_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Zahlungsart`)
};

const ru_onbilgi_s4_heading = /** @type {(inputs: Onbilgi_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Способ оплаты`)
};

/**
* | output |
* | --- |
* | "4. Payment Method" |
*
* @param {Onbilgi_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s4_heading = /** @type {((inputs?: Onbilgi_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s4_heading(inputs)
	if (locale === "de") return de_onbilgi_s4_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s4_heading(inputs)
	return tr_onbilgi_s4_heading(inputs)
});